export default "__VITE_ASSET__b883c47b__"